/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import EffectSequence from '../../../Effects/EffectSequence';
import ComponentReference from '../ComponentReference/ComponentReference';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import ReferencedComponent from '../ComponentReference/ReferencedComponent';
import { ReferenceGroup } from '../ComponentReference/ReferenceGroup';
import AnimationInstanceBase from './AnimationInstanceBase';

export default class EffectSequenceAnimationInstance extends AnimationInstanceBase<EffectSequence>
{
    private _defaultEffectSequence: EffectSequence = null;

    public Play(dt: number = 1): Promise<any>
    {
        return new Promise<any>((resolve, reject) =>
            {
                let onComplete: (args: any) => void;
                const resolver: (args: any) => void = () =>
                {
                    this.animation.OffComplete(onComplete);
                    resolve(true);
                };

                // If looping, onComplete will restart the effect sequence.
                if (this.options.Loop)
                {
                    this.animation.node.once(AnimationInstanceBase.StoppedEvent, resolver);

                    onComplete = () =>
                    {
                        // Loop
                        this.animation.ResetSequence();
                        this.animation.Trigger();
                    };
                }
                else
                {
                    onComplete = resolver;
                }

                try
                {
                    this.animation.OnComplete(onComplete);
                    this.animation.Trigger();
                }
                catch (error)
                {
                    reject(error);
                }
            });
    }

    public Stop(): EffectSequenceAnimationInstance
    {
        this.animation.Stop();

        // Play optional default effect sequence, i.e. for returning a logo anim to its idle animation.
        if (this.hasDefaultAnimation())
        {
            if (!this._defaultEffectSequence)
            {
                const referenced: ReferencedComponent = ComponentReference.Get(
                    ReferencedComponent,
                    ReferenceGroup.MainGame,
                    this.options.DefaultAnimation
                );

                if (referenced) { this._defaultEffectSequence = referenced.getComponent(EffectSequence); }
            }

            if (this._defaultEffectSequence)
            {
                this._defaultEffectSequence.Trigger();
            }
        }

        this.emitStopped();
        return this;
    }
}
